if (!window.cartPackUpsellReady) {
  window.cartPackUpsellReady = true;

  const postCart = (url, body) =>
    fetch(url, { ...fetchConfig(), body: JSON.stringify(body) }).then((response) =>
      response.json().then((json) => {
        if (!response.ok || json.status) throw new Error(json.description || json.message || 'Something went wrong');
        return json;
      })
    );

  const showLineError = (button, message) => {
    const errorText = button.closest('[data-line]')?.querySelector('.cart-item__error-text');
    if (errorText) errorText.textContent = message;
  };

  const setBusy = (button, busy) => {
    button
      .closest('[data-line]')
      ?.querySelector('.loading__spinner')
      ?.classList.toggle('hidden', !busy);
    button
      .closest('.pack-upsell')
      .querySelectorAll('[data-pack-upsell]')
      .forEach((upsellButton) => {
        upsellButton.disabled = busy;
        upsellButton.setAttribute('aria-busy', busy);
      });
  };

  const packName = (size) => (Number(size) > 1 ? `${size} Pack` : 'Single');

  const swapToPack = async (button) => {
    const { lineKey, lineVariantId, variantId, packLineKey } = button.dataset;
    const quantity = Number(button.dataset.quantity);
    const parsedProperties = JSON.parse(button.dataset.properties || '{}');
    const properties = Array.isArray(parsedProperties) ? {} : parsedProperties;
    const hasProperties = Object.keys(properties).length > 0;
    const fromPackSize = button.closest('.pack-upsell').dataset.linePackSize;
    const upgradeProperties = {
      ...properties,
      _pack_upgrade: `${packName(fromPackSize)} → ${packName(button.dataset.packSize)}`,
    };
    setBusy(button, true);
    showLineError(button, '');

    try {
      if (packLineKey && !hasProperties) {
        const packQuantity = Number(button.dataset.packLineQuantity) + quantity;
        await postCart(routes.cart_update_url + '.js', { updates: { [lineKey]: 0, [packLineKey]: packQuantity } });
      } else {
        await postCart(routes.cart_change_url + '.js', { id: lineKey, quantity: 0 });
        try {
          await postCart(routes.cart_add_url + '.js', {
            items: [{ id: Number(variantId), quantity, properties: upgradeProperties }],
          });
        } catch (error) {
          await postCart(routes.cart_add_url + '.js', { items: [{ id: Number(lineVariantId), quantity, properties }] });
          throw error;
        }
      }
    } catch (error) {
      setBusy(button, false);
      showLineError(button, error.message);
      return;
    }

    publish(PUB_SUB_EVENTS.cartUpdate, { source: 'pack-upsell', variantId });
  };

  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-pack-upsell]');
    if (!button || button.disabled) return;
    event.preventDefault();
    swapToPack(button);
  });
}
